var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** O que a view do editor de faixas de status desenha. */
let BandScope = class BandScope extends Scope {
    constructor() {
        super(...arguments);
        this.level = '';
        this.label = '';
        this.color = '';
        this.min = '';
        this.max = '';
        /**
         * O prefixo do `name` dos dois campos - `102.CRITICAL`.
         *
         * E o caminho que o `register` do react-hook-form escreve na referencia
         * (`${sectionId}.${status.level}`), e por isso os campos de la tem
         * `name="102.CRITICAL.min"`. Sem isso os campos do porte ficam sem nome, o que
         * muda o DOM e tira deles a ancora que um formulario da a cada campo.
         */
        this.field = '';
        /** Se esta faixa foi decidida NESTE nivel, em vez de herdada do de cima. */
        this.diverges = false;
        this.onMinChanged = Scope.SYNC_ACTION_STRING;
        this.onMaxChanged = Scope.SYNC_ACTION_STRING;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], BandScope.prototype, "level", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BandScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BandScope.prototype, "color", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BandScope.prototype, "min", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BandScope.prototype, "max", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BandScope.prototype, "field", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BandScope.prototype, "diverges", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], BandScope.prototype, "inherited", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], BandScope.prototype, "inheritedMin", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], BandScope.prototype, "inheritedMax", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], BandScope.prototype, "inheritedSource", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], BandScope.prototype, "warning", void 0);
BandScope = __decorate([
    Observable
], BandScope);
export { BandScope };
let IndicatorScope = class IndicatorScope extends Scope {
    constructor() {
        super(...arguments);
        this.measurementTypeId = 0;
        this.label = '';
        this.unit = '';
        this.bands = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IndicatorScope.prototype, "measurementTypeId", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IndicatorScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IndicatorScope.prototype, "unit", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IndicatorScope.prototype, "bands", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], IndicatorScope.prototype, "warning", void 0);
IndicatorScope = __decorate([
    Observable
], IndicatorScope);
export { IndicatorScope };
let StatusBandsScope = class StatusBandsScope extends Scope {
    constructor() {
        super(...arguments);
        this.indicators = [];
        /**
         * Os vaos e sobreposicoes do conjunto que esta na tela, um por problema.
         *
         * Vazio no caso comum. E a soma de `gaps` e `overlaps`, e se repete no aviso de
         * salvamento, porque e ali que a pessoa acha que terminou.
         */
        this.warnings = [];
        /** Os VAOS: nao impedem salvar - um vao pode ser deliberado, e recusar decidiria pelo cliente. */
        this.gaps = [];
        /** As SOBREPOSICOES: o salvamento as recusa, como o servidor (ver `finalOverlap`). */
        this.overlaps = [];
        this.busy = false;
        this.dirty = false;
        /**
         * Se ha sobrescrita PROPRIA a desfazer.
         *
         * Falso quando a tela ja esta mostrando valores herdados - nesse caso nao ha o
         * que apagar, e oferecer o botao prometeria uma acao sem efeito.
         */
        this.canFollowDefaults = false;
        /**
         * Conta quantas vezes os valores foram trocados PELO PRESENTER.
         *
         * Os campos sao nao controlados, e um campo nao controlado ignora mudanca de
         * `defaultValue` - so o `key` o faz remontar. Amarrar o `key` ao valor nao
         * basta: digitar nao redesenha (o scope atualiza em lote e ninguem agenda o
         * redesenho por tecla), entao o React nunca ve o valor digitado no `key`, e
         * voltar ao valor original nao muda chave alguma. O "Cancelar" trocava o scope
         * e a tela seguia com o que havia sido digitado.
         *
         * Com este contador no `key`, toda escrita programatica remonta os campos.
         */
        this.revision = 0;
        /**
         * O titulo, que diz DE QUEM sao os limites desta tela.
         *
         * Um por nivel - do Sistema, da Empresa, os Meus, do Colaborador. O nivel
         * pessoal era o unico sem dono no titulo, e com a linha de origem falando da
         * plataforma logo abaixo ele parecia editar a plataforma.
         */
        this.title = '';
        /**
         * QUEM estes limites alcancam - a pergunta que o titulo nao responde.
         *
         * "De quem sao" e "sobre quem valem" sao duas coisas, e a segunda e a que muda
         * a decisao de mexer: os meus limites nao classificam colaborador nenhum, e os
         * da empresa classificam todos os que nao tiverem os proprios.
         */
        this.appliesTo = '';
        /**
         * Se cabe oferecer "Restaurar Padrões".
         *
         * Quem edita os PADROES nao tem a que restaurar - e por isso o botao nao
         * aparece para o super admin, como na referencia.
         */
        this.canRestoreDefaults = false;
        /**
         * Se o editor tem cabecalho proprio com "Expandir"/"Recolher".
         *
         * O do COLABORADOR tem, e comeca recolhido - sao quatro faixas por indicador
         * dentro de uma tela que ja e longa. O de "Meus dados" nao tem: o titulo fica
         * dentro do primeiro cartao e tudo aparece aberto.
         */
        this.collapsible = false;
        this.onSave = Scope.ASYNC_ACTION;
        this.onReset = Scope.ASYNC_ACTION;
        /** Volta as faixas para os padroes da plataforma, descartando as proprias. */
        this.onRestoreDefaults = Scope.ASYNC_ACTION;
        this.onFollowDefaults = Scope.ASYNC_ACTION;
    }
    /*
     * Os textos dos dois avisos moram aqui, e nao na view: o que eles dizem depende de
     * haver ou nao sobreposicao, e "da para salvar" so pode aparecer quando da.
     */
    get overlapTitle() {
        return 'Há faixas que se sobrepõem, e assim não dá para salvar:';
    }
    get overlapNote() {
        return ('Uma medição no trecho em comum seria contada nos dois níveis. ' +
            'Corrija os limites antes de confirmar as edições.');
    }
    get gapTitle() {
        return 'As faixas de um indicador precisam se encostar, e estas não se encostam:';
    }
    /** Sozinho, o vao deixa salvar; junto de uma sobreposicao, o aviso nao pode prometer isso. */
    get gapNote() {
        const effect = 'uma medição que caia num vão é classificada pelo nível de cima, e não pelo limite que você escreveu.';
        return this.overlaps.length > 0
            ? `Os vãos, por si, não impedem salvar - mas ${effect}`
            : `Dá para salvar assim - mas ${effect}`;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Array)
], StatusBandsScope.prototype, "indicators", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], StatusBandsScope.prototype, "warnings", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], StatusBandsScope.prototype, "gaps", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], StatusBandsScope.prototype, "overlaps", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "busy", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], StatusBandsScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "dirty", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], StatusBandsScope.prototype, "inheritedFrom", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "canFollowDefaults", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "revision", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "appliesTo", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "canRestoreDefaults", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBandsScope.prototype, "collapsible", void 0);
StatusBandsScope = __decorate([
    Observable
], StatusBandsScope);
export { StatusBandsScope };
//# sourceMappingURL=status-bands.scope.js.map